import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { serverError } from './../../../../core/models/messages';
import { MaillingServiceService } from './../../../../core/services/mailingService/mailling-service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import {
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  takeUntil,
} from 'rxjs';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-mailing',
  templateUrl: './mailing.component.html',
  styleUrls: ['./mailing.component.css'],
})
export class MailingComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  mailingForm: FormGroup = this.createForm();
  private unsubscribeAll: Subject<void> = new Subject();
  companyType: any;
  currentUser: any;
  EmployeesList: any;
  MailingList: any;
  emailFormControl!: FormControl;
  mode: string = 'create_mailing';
  searchInputSubject = new Subject<string>();
  idMail!: number;
  /* modal */
  modalRef?: BsModalRef;
  searchElement: string = '';
  clickCount: number = 0;
  totalItems!: number;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentPage: number = 0;
  startIndex: number = 0;
  endIndex: number = 5;
  itemsPerPage: number = 5;
  pagination : boolean =false;
  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private mailingService: MaillingServiceService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef
  ) {}
  ngOnInit() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));

    this.getcurrentUser();
    this.getListEmployees();
    this.getListMailing();
  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyType = JSON.parse(this.currentUser).company.type;
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  createForm(mode?: string, data?: any) {
    return this.formBuilder.group({
      employee_id: [data ? data.employee_id : null, Validators.required],
      contactName: [data ? data.contactName : '', Validators.required],
      contactMail: [data ? data.contactMail : '', [Validators.email]],
    });
  }
  getListEmployees() {
    this.mailingService
      .getListEmployees()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.EmployeesList = res.data;
          this.mailingForm
            .get('email')
            ?.setValue(this.EmployeesList.contactMail);
        },
        error: () => {
          this.toastrService.error(serverError);
        },
      });
  }
  getListMailing() {
    this.spinner.show();
    let data = {
      per_page: this.itemsPerPage,
      page: this.currentPage,
    };
    this.mailingService
      .getListMailing(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.MailingList = res.data.data;
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
          this.toastrService.error(serverError);
        },
      });
  }
  confirmer() {
    if (this.mode == 'create_mailing') {
      this.addMailling();
    } else {
      this.updateMailling();
    }
  }
addMailling() {
  this.spinner.show();
  this.mailingService
    .addMailing({...this.mailingForm.value })
    .subscribe({
      next: (res: any) => {
        this.toastrService.success('L’adresse mail a été ajoutée avec succès.');
        this.getListMailing();
        this.closeModal();
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        // @todo: utiliser le message d'erreur du serveur avec traduction
        if (err.error.message === 'mailing already exsist') {
          this.toastrService.error('Le mailing existe déjà.');
        } else {
          this.toastrService.error(err.error.message);
        }
      },
    });
}


  updateMailling() {
    this.spinner.show();
    this.mailingService
      .updateMailing(this.mailingForm.value, this.idMail, this.companyType)
      .subscribe({
        next: (res: any) => {
          this.toastrService.success('Mail modifier avec succès.');
          this.getListMailing();
          this.getListEmployees();
          this.closeModal();
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastrService.error(serverError);
        },
      });
  }
  deleteMailing(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#ff0000',
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Annuler',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.mailingService.deleteMailing(id).subscribe((res: any) => {
          Swal.fire('Supprimé !', 'mail a été supprimé.', 'success');
          this.getListMailing();
          this.spinner.hide();
        });
      }
    });
  }
  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.searchInputSubject.next(filterValue);
  // }
  applyFilter(pageNumber : number = this.currentPage) {
    this.btnSearchactive=true;
    if (this.searchElement != '' || this.clickCount) {
      this.clickCount++;

      const data = {
        search: this.searchElement.trim().toLowerCase(),
        per_page: this.pageSize,
        page: this.currentPage
      };
      this.spinner.show();
      this.mailingService .searchListMailing(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.MailingList = res.data.data;
            this.totalItems = res.data.total;
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
            this.toastrService.error(serverError);
          },
        });
    }
  }

   onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.btnSearchactive) {
        this.applyFilter(this.currentPage);
      } 
      else {
        this.getListMailing();
      }
    }
  openModal(template: TemplateRef<any>, mode: string, data?: any) {
    this.mailingForm = this.createForm(mode, data);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.mode = mode;
    this.getListMailing();
    if (mode =='update_mailing') {
      this.idMail = data?.id;
    }
  }

  onEmployeeSelected(selectedEmployeeId: any) {
    if (selectedEmployeeId !== null && selectedEmployeeId !== undefined) {
      const selectedEmployee = this.EmployeesList.find(
        (employee: any) => employee.uuid === selectedEmployeeId.uuid
      );
      if (selectedEmployee) {
        let emailToDisplay =
          selectedEmployee.emailProESN || selectedEmployee.emailProClient;
        if (!emailToDisplay) {
          emailToDisplay = selectedEmployee.email;
        }
        this.mailingForm.get('contactMail')?.setValue(emailToDisplay);
      }
    }
  }
  onReset(){
    this.currentPage=0;
    this.searchElement='';
    this.btnSearchactive = false;
    this.getListMailing()
 } 
  closeModal() {
    this.modalRef!.hide();
    this.mailingForm.reset();
    this.mailingForm = this.createForm();
  }

    /* get indexes for pagination */
    getItems(event?: any) {
      if (
        (event && event.startIndex != this.startIndex) ||
        this.endIndex != event.endIndex ||
        this.itemsPerPage != event.itemsPerPage ||
        this.currentPage != event.currentPage
      ) {
        this.startIndex = event.startIndex;
        this.endIndex = event.endIndex;
        (this.itemsPerPage = event.itemsPerPage),
          (this.currentPage = event.currentPage);
        if (this.searchElement != '') this.applyFilter();
        else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){
            this.pagination = true
        this.getListMailing();
        }
      }
    }

}
